import React, { useEffect, useState } from "react";
import Brand from "../shared/brand/Brand";
import Nav from "../shared/nav/Nav";
import { EndComponentHolder, MobileNavigationContainer, MobileNavigationSpacer } from "./MobileNavigationStyles";
import { EnvIndicator } from "./env";
import LinksContainer from "./links/container/LinksContainer";
import NavHamburger from "./navHamburger/NavHamburger";
import Navbar from "./navbar/Navbar";
import QuickLinks from "./quicklink/QuickLinks";
import MobileNavStatus from "./status/MobileNavStatus";
const MobileNavigation = ({ config, customLinkComponent }) => {
    const { loggedIn, username, centerLogo, endLogo, endComponent, navigationLinks = [], usernameDropdownLinks = [], env = "prod", displayEnvIndicator = false, displayPermissionsIndicator = false, permissions, status, } = config;
    const [navOpen, setNavOpen] = useState(false);
    const [quickLinks, setQuickLinks] = useState([]);
    const [mobileLinks, setMobileLinks] = useState([]);
    useEffect(() => {
        const links = navigationLinks.filter((link) => link.visible !== false);
        if (!!username && !!usernameDropdownLinks?.length) {
            links.push({
                name: username,
                subLinks: usernameDropdownLinks.filter((link) => link.visible !== false),
            });
        }
        setMobileLinks(links);
    }, [navigationLinks, usernameDropdownLinks]);
    useEffect(() => {
        const qls = navigationLinks
            .map((link) => {
            const links = [link];
            return !!link.subLinks ? links.concat(link.subLinks.filter((sub) => sub.quickLink)) : links;
        })
            .reduce((a, b) => a.concat(b), [])
            .filter((link) => !!link.quickLink && link.visible);
        setQuickLinks(qls.slice(0, 4));
    }, [navigationLinks]);
    return (React.createElement(React.Fragment, null,
        React.createElement(MobileNavigationContainer, null,
            displayEnvIndicator && React.createElement(EnvIndicator, { env: env }),
            React.createElement(Navbar, { displayEnvIndicator: displayEnvIndicator },
                loggedIn && (React.createElement(React.Fragment, null,
                    React.createElement(NavHamburger, { open: navOpen, toggle: setNavOpen }),
                    React.createElement(Nav, null,
                        React.createElement(QuickLinks, { links: quickLinks, customLinkComponent: customLinkComponent })))),
                !!centerLogo && (React.createElement(Nav, { align: "center" },
                    React.createElement(Brand, { logo: centerLogo.logo, text: centerLogo.text, link: centerLogo.link, contentHeight: centerLogo.logoHeight, customLinkComponent: customLinkComponent }))),
                !!endLogo && (React.createElement(Nav, { align: "end" },
                    React.createElement(Brand, { logo: endLogo.logo, text: endLogo.text, link: endLogo.link, contentHeight: endLogo.logoHeight, customLinkComponent: customLinkComponent }))),
                loggedIn && (React.createElement(React.Fragment, null, !!endComponent && (React.createElement(Nav, null,
                    React.createElement(EndComponentHolder, null, endComponent)))))),
            navOpen && (React.createElement(LinksContainer, { links: mobileLinks, closeMenu: () => setNavOpen(false), permissions: permissions, displayEnvIndicator: displayEnvIndicator, displayPermissionsIndicator: displayPermissionsIndicator, displayStatusIndicator: loggedIn && !!status?.text?.length, customLinkComponent: customLinkComponent }))),
        loggedIn && React.createElement(MobileNavStatus, { status: status, displayEnvIndicator: displayEnvIndicator }),
        React.createElement(MobileNavigationSpacer, { displayEnvIndicator: displayEnvIndicator, hasStatus: loggedIn && !!status?.text?.length })));
};
export default MobileNavigation;
//# sourceMappingURL=MobileNavigation.js.map